<template>
  <router-view class="view"></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data: () => ({
  }),
  methods: {
  },
  created () {
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    }
  },
};
</script>
